import { componentStyle } from '@/styling/util/component-style.ts';
import type { StepperDesignTokens } from '@primeuix/themes/types/stepper';

export const stepperStyle = componentStyle<StepperDesignTokens>({
    stepTitle: {
        color: '{color.text}',
        fontWeight: '400',
        activeColor: '{color.text}',
    },
    stepNumber: {
        background: '{color.backgroundLightblue}',
        activeBackground: '{color.backgroundLightblue}',
        borderColor: '{color.borderLightGray}',
        activeBorderColor: '{color.borderLightGray}',
        color: '#00529e',
        activeColor: '#00529e',
    },
    separator: {
        activeBackground: '#bcc3cd',
        background: '#bcc3cd',
    },
});
